export default __webpack_public_path__ + "static/media/edgeimpulse-logo.d2a3c474.svg";